<template>
  <div>
    <el-row>
      <el-col :span="12">
        <el-row>
          <el-col>
            <rest-form-item
              prop="name"
              :label="$t('ApplicationForm_Field_Title')"
            >
              <el-input v-model="model.name" data-qa="web-app-title-input" />
            </rest-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <rest-form-item
              prop="web_title"
              :label="$t('ApplicationForm_Field_WebsiteTitle')"
            >
              <el-input
                v-model="model.web_title"
                data-qa="web-app-website-title-input"
              />
            </rest-form-item>
          </el-col>

          <el-col>
            <rest-form-item
              prop="web_url"
              :label="$t('ApplicationForm_Field_WebsiteURL')"
            >
              <el-input v-model="model.web_url" data-qa="web-app-url-input" />
            </rest-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <rest-form-item
              prop="web_domain"
              :label="$t('ApplicationForm_Field_AllowedHTTPOrigins')"
            >
              <el-input
                type="textarea"
                v-model="model.web_domain"
                :rows="6"
                data-qa="web-app-domain-input"
              />
            </rest-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <rest-form-item
              prop="c"
              :label="$t('ApplicationForm_Field_ClientCookies')"
            >
              <el-switch
                v-model="clientCookies"
                :inactive-value="false"
                :active-value="true"
                data-qa="web-app-cookies-switch"
              />
            </rest-form-item>
          </el-col>
        </el-row>

        <el-row class="example-row" v-if="clientCookies">
          <el-col>
            <rest-form-item
              :hint="
                `${$t('ApplicationForm_Row_WebsiteSettingsPrefixDomain')} ${$t(
                  'ApplicationForm_Row_WebsiteSettingsExample'
                )}`
              "
              prop="web_push_cookie_domain"
              :label="$t('ApplicationForm_Field_CookieDomain')"
            >
              <el-input
                ref="cookie-domain"
                v-model="model.webpush_cookie_domain"
                data-qa="web-app-cookie-domain-input"
              />
            </rest-form-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row>
          <el-col class="el-col-" :span="null">
            <rest-form-item
              prop="web_icon_small_file"
              :label="$t('ApplicationForm_Field_SmallIcon')"
            >
              <icon-upload
                :value="model.web_icon_small"
                :file.sync="model.web_icon_small_file"
                accepts=".png"
                data-qa="small-icon-upload"
              />
            </rest-form-item>
          </el-col>
          <el-col class="el-col-" :span="null">
            <rest-form-item
              prop="web_icon_large_file"
              :label="$t('ApplicationForm_Field_LargeIcon')"
            >
              <icon-upload
                :value="model.web_icon_large"
                :file.sync="model.web_icon_large_file"
                accepts=".png"
                data-qa="large-icon-upload"
              />
            </rest-form-item>
          </el-col>
          <el-col>
            <rest-form-item
              prop="ga_tracking_id"
              :label="$t('ApplicationForm_Field_GaTrackingId')"
            >
              <el-input
                v-model="model.ga_tracking_id"
                maxlength="32"
                placeholder="G-XXXXXX"
                data-qa="web-app-tracking-id-input"
              />
            </rest-form-item>
          </el-col>
          <el-col>
            <rest-form-item
              prop="c"
              :label="$t('ApplicationForm_Field_AutoCreateEvents')"
            >
              <el-switch
                v-model="model.auto_create_events"
                :inactive-value="0"
                :active-value="1"
                data-qa="web-app-auto-create-events-switch"
              />
            </rest-form-item>
          </el-col>
          <el-col>
            <rest-form-item
              prop="c"
              :label="$t('ApplicationForm_Field_AutoCreateTags')"
            >
              <el-switch
                v-model="model.auto_create_tags"
                :inactive-value="0"
                :active-value="1"
                data-qa="web-app-auto-create-tags-switch"
              />
            </rest-form-item>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import RestFormItem from '@/common/components/rest/RestFormItem'
import IconUpload from '@/common/components/form/IconUpload'

export default {
  name: 'AppWebForm',
  components: { IconUpload, RestFormItem },
  props: {
    model: {
      required: true,
      type: Object
    },
    files: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      clientCookies: !!this.model.webpush_cookie_domain
    }
  },
  methods: {
    save() {
      this.$refs['form'].save()
    }
  },
  watch: {
    clientCookies(newValue) {
      if (!newValue) {
        this.$refs['cookie-domain'].clear()
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/account/components/AppWebForm.vue